import { request } from '@/network/axios'
import { keysToCamelCase, keysToSnakeCase } from '@/utils'

const canTransform = (value: unknown) =>
  Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]'

export const transformApiRequest = <T>(payload?: T): T | undefined => {
  if (payload == null) return payload
  return canTransform(payload) ? keysToSnakeCase(payload) : payload
}

export const transformApiResponse = <T>(payload: unknown): T => {
  return canTransform(payload) ? keysToCamelCase(payload as T) : (payload as T)
}

export const apiGet = async <T>(url: string, params?: object): Promise<T> => {
  const response = await request.get<any>(url, transformApiRequest(params))
  return transformApiResponse<T>(response)
}

/** 新平台接口使用全链路 camelCase，查询参数不做历史 snake_case 转换。 */
export const apiGetCamelCase = async <T>(url: string, params?: object): Promise<T> => {
  const response = await request.get<any>(url, params)
  return transformApiResponse<T>(response)
}

export const apiPost = async <T>(url: string, data?: object, params?: object): Promise<T> => {
  const response = await request.post<any>(url, transformApiRequest(data), transformApiRequest(params))
  return transformApiResponse<T>(response)
}

/** 新平台接口使用全链路 camelCase，请求体不做历史 snake_case 转换。 */
export const apiPostCamelCase = async <T>(url: string, data?: object, params?: object): Promise<T> => {
  const response = await request.post<any>(url, data, params)
  return transformApiResponse<T>(response)
}

export const apiPut = async <T>(url: string, data?: object, params?: object): Promise<T> => {
  const response = await request.put<any>(url, transformApiRequest(data), transformApiRequest(params))
  return transformApiResponse<T>(response)
}

export const apiDelete = async <T>(url: string, data?: object): Promise<T> => {
  const response = await request.delete<any>(url, data ? { data: transformApiRequest(data) } : undefined)
  return transformApiResponse<T>(response)
}

export const apiPatch = async <T>(url: string, data?: object): Promise<T> => {
  const response = await request.patch<any>(url, transformApiRequest(data))
  return transformApiResponse<T>(response)
}

/** 新平台接口使用全链路 camelCase，请求体不做历史 snake_case 转换。 */
export const apiPatchCamelCase = async <T>(url: string, data?: object): Promise<T> => {
  const response = await request.patch<any>(url, data)
  return transformApiResponse<T>(response)
}
